import React, { useCallback } from 'react';
import { AutoComplete, Input } from 'antd';
import { useNavigate } from '@common/hooks';
import debounce from 'lodash/debounce';
export const SearchBar = ({
  searchResults,
  onSearch,
  loading,
  debounceTiming = 300,
}: {
  searchResults: {
    label: React.ReactNode;
    redirectToUrl?: string;
    options: {
      key?: string;
      value: string;
      label: React.ReactNode | string;
    }[];
  }[];
  onSearch: (value: string) => void;
  loading?: boolean;
  debounceTiming?: number;
}) => {
  const navigate = useNavigate();

  // FIXME: need to make onSearch stable and use proper deps,
  //  using it like this might cause hard to find bugs!!
  const loadResults = useCallback(debounce(onSearch, debounceTiming), []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <AutoComplete
        dropdownMatchSelectWidth={500}
        options={searchResults}
        onSearch={loadResults}
        onSelect={(_, option) => navigate(option.redirectToUrl || '')}
        className="SearchBar sentry-mask"
      >
        <Input.Search size="large" placeholder="Search" loading={loading} />
      </AutoComplete>
      <style jsx>{`
        :global(.SearchBar) {
          min-width: 100%;
        }
      `}</style>
    </>
  );
};
